import { b as l } from "./withEditable-7d0a220a.js";
import { jsx as t } from "react/jsx-runtime";
import { TagsGroup as i } from "@ucl/react-library";
import "@adobe/aem-spa-page-model-manager";
import "html-react-parser";
import "sanitize-html";
import { s as n } from "./sanitizeProps-304c699d.js";
import "@adobe/aem-react-editable-components";
import "react";
import "./PageContext-57b2437f.js";
import "./component-a7888ba1.js";
import "./EditableComponentUtils-0b5699b7.js";
import "@ucl/react-library/useIsMounted";
import "./ComponentContext-3bb2d205.js";
import "./withErrorBoundary.js";
import "@ucl/shared-component-foundations/foundations";
import "styled-components";
import "./index-0371017d.js";
const m = ({ tags: o = [], children: p, ...r }) => /* @__PURE__ */ t(i, {
  overflow: r.overflow,
  overflowVariant: r.overflowVariant,
  visibleTags: r.visibleTags,
  ...n(r),
  children: p || (o == null ? void 0 : o.map((a, e) => /* @__PURE__ */ t(i.Tag, {
    ...a
  }, e)))
});
m.displayName = "TagGroup";
const s = (o) => o.tags == null || !o.tags.length, T = "ucl/components/taggroup", g = {
  emptyLabel: "TagGroup",
  isEmpty: s,
  resourceType: T
}, V = l(g, m);
export {
  V as EditableTagGroup,
  T as TAG_GROUP_RESOURCE_TYPE
};
